


































































import { computed, defineComponent } from "@vue/composition-api";
export default defineComponent({
  props: {
    color: {
      default: "primary"
    },
    title: String,
    width: {
      default: 500
    },
    value: {
      default: false
    },
    name: {
      default: ""
    },
    back: {
      default: false
    }
  },
  setup(props, ctx) {
    const model = computed({
      get: () => props.value,
      set: () => ctx.emit("input", false)
    });

    return {
      model
    };
  }
});
